import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn, initialsOf } from "@/lib/utils";
import { relAgo } from "@/components/placements/placementsShared";
import { DSTATE } from "./discussionsShared";
import { useLang } from "@/i18n";

export default function DiscussionListItem({ item, selected, onClick }) {
  const { tf } = useLang();
  const st = DSTATE[item.state?.state] || DSTATE.ACTIVE;
  const a = item.athlete || {};
  const next = item.next_action?.note || item.current_milestone_label;
  const li = a.last_interaction_at;
  return (
    <button
      onClick={onClick}
      data-testid={`discussion-item-${item.id}`}
      aria-current={selected ? "true" : undefined}
      className={cn(
        "w-full text-left rounded-2xl border p-3.5 transition-colors",
        selected
          ? "border-foreground/30 bg-secondary/60 ring-1 ring-foreground/15"
          : "border-border dark:border-white/[0.08] bg-card hover:border-foreground/20 dark:hover:border-white/20"
      )}
    >
      <div className="flex items-start gap-3">
        <Avatar className="h-10 w-10 shrink-0">
          <AvatarImage src={a.photo_url || undefined} alt="" />
          <AvatarFallback className="text-xs font-semibold bg-secondary">{initialsOf(a.name)}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-1.5 min-w-0">
              <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", st.dot)} />
              <span className="text-sm font-semibold truncate">{a.name}</span>
            </div>
            <span className={cn("shrink-0 text-[10px] font-medium rounded-full border px-2 py-0.5", st.chip)}>
              {tf(st.label)}
            </span>
          </div>
          <div className="text-xs text-muted-foreground truncate mt-0.5">
            {[a.club, a.position, a.age ? `${a.age} ans` : null].filter(Boolean).join(" · ") || "—"}
          </div>
          <div className="text-[11px] text-muted-foreground/80 mt-1.5 space-y-0.5">
            <div>{li ? `${tf("Dernier échange")} ${relAgo(li)?.toLowerCase()}` : tf("Aucun échange enregistré")}</div>
            {next && <div className="truncate">{tf("Prochaine étape")} : {next}</div>}
          </div>
        </div>
      </div>
    </button>
  );
}
